export const States =
{
    ACT: "Australian Capital Territory",
    NSW: "New South Wales",
    NT: "Northern Territory",
    QLD: "Queensland",
    SA: "South Australia",
    TAS: "Tasmania",
    VIC: "Victoria",
    WA: "Western Australia",

    toListItems: () =>
    {
        return [ 'ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA' ].map( key =>
        {
            const states = <unknown>States as Record<string, string>;
            return { value: states[ key ], title: states[ key ] };
        });
    }
};
